import { ShippingMethod, ShippingMethodResult } from '~/lib/data-contract/salesforce';
import { DeliveryMethod } from '../models/checkout';

const getApplicableShippingMethods = (shipmentMethods: ShippingMethodResult) =>
    shipmentMethods?.applicableShippingMethods?.filter(
        (method) => method.c_isApplicable
    ) as ShippingMethod[];

export const splitByDeliveryType = (
    carriers: ShippingMethodResult
): Record<DeliveryMethod, ShippingMethod[]> => {
    const dropPoint = [];
    const addressDelivery = [];
    const clickAndCollect = [];
    const truckDelivery = [];
    const virtual = [];

    const applicableCarriers = getApplicableShippingMethods(carriers);

    for (const element in applicableCarriers) {
        if (applicableCarriers[element].c_shippingType === 'TRUCK') {
            truckDelivery.push(applicableCarriers[element]);
        }
        if (applicableCarriers[element].c_shippingType === 'CLICK_AND_COLLECT') {
            clickAndCollect.push(applicableCarriers[element]);
        }
        if (applicableCarriers[element].c_shippingType === 'ADDRESS_DELIVERY') {
            addressDelivery.push(applicableCarriers[element]);
        }
        if (applicableCarriers[element].c_shippingType === 'DROPPOINT') {
            dropPoint.push(applicableCarriers[element]);
        }
        if (applicableCarriers[element].c_shippingType === 'VIRTUAL_DELIVERY') {
            virtual.push(applicableCarriers[element]);
        }
    }

    return { dropPoint, addressDelivery, clickAndCollect, truckDelivery, virtual };
};
